import { useState, useEffect } from "react";

import Config from "../../Config";

import empty_user from "../../empty_user.png";

import superx from "../../superx.png";
import supery from "../../supery.png";

function WallLike(props)
{

    const[tab,setTab] = useState(props.tab);
    const[view,setView] = useState("line");


    const changeView = () => {
        if(view == "line")  {setView("list");} else setView("line");
    }



    const setLike = (e) => {

       
        var operacja = e.target.getAttribute("t");
 
            props.mainView.setProgress(-2);
    
            var req = {
                id: props.typId,
                typ: '1',
                operacja:operacja
            };
    
            fetch( Config.url + '/rest_v1_news,set_like', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => { 
    
                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);              
                        }
             } )
             .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
             });
                       
    
             return false;
      
    
    }


    var persons = tab.length;

    var likeIt = <img  src={superx} t="1" onClick={setLike} className="likebtn" />
    var iLikeIt = false;

    for(var k=0; k<tab.length; k++)
    {
        if(tab[k].wlasciciel == '1') iLikeIt = true;
    }

    ;

    if(iLikeIt)
    {
        likeIt = <img  src={supery}  t="0" onClick={setLike} className="likebtn"/>
    } 


    if(view == "list")
    {
        return (
            <div className="item_like" >
            {likeIt}  Reakcji: {persons} <span onClick={changeView} className="link_color">-ukryj-</span>

                <div className="quickPopup shadowx">
                        
                        {  tab.map(  (item, ix) => {

                                var defAwatar =           <img  src={empty_user} />
                                if(item.awatar.length> 10) defAwatar=<img  src={ "data:image/jpeg;base64, " + item.awatar} />

                                return <div className="qitem">
                                    {defAwatar}  {item.imie} {item.nazwisko} 
                                </div>

                        } ) }
                
              </div>
              

            </div> 
        )
       
    }


    return (
        <div className="item_like" >
              {likeIt}  Reakcji: {persons} <span onClick={changeView} className="link_color">-pokaż-</span>
        </div> 
    )
}

export default WallLike;